export default __webpack_public_path__ + "static/media/PegasusLogo.35b2b70c.png";